import React from 'react';
import { Input } from '@avila-tek/ui/src';
import { PaymentMethod } from '../../../../models';
import PaymentStepLayout from '../PaymentStepLayout';
import PaymentDataOption from './PaymentDataOption';

interface PaymentDataStepProps {
  setStepSelected: React.Dispatch<React.SetStateAction<number>>;
  stepSelected: number;
  paymentMethodSelected: PaymentMethod;
  paymentReference: string;
  setPaymentReference: React.Dispatch<React.SetStateAction<string>>;
}

function PaymentDataStep({
  setStepSelected,
  stepSelected,
  paymentMethodSelected,
  paymentReference,
  setPaymentReference,
}: PaymentDataStepProps) {
  return (
    <PaymentStepLayout
      title="Información de pago"
      num={2}
      collapsed={stepSelected === 2}
      setStepSelected={setStepSelected}
      paymentMethod={paymentMethodSelected}
      paymentReference={paymentReference}
    >
      <div className="w-full flex items-center flex-col sm:flex-row">
        <div className="my-3 mt-5 pl-2 flex flex-col gap-5 w-full sm:w-1/2">
          {paymentMethodSelected?.paymentData?.map((item) => (
            <PaymentDataOption key={item.name} paymentData={item} />
          ))}
        </div>
        {!paymentMethodSelected?.automated ? (
          <div className="my-3 mt-5 pl-2 flex flex-col gap-5 w-full sm:w-1/2">
            <Input
              label="Número de referencia de la transacción"
              value={paymentReference}
              onChange={(e) => setPaymentReference(e.target.value)}
            />
          </div>
        ) : null}
      </div>
    </PaymentStepLayout>
  );
}

export default PaymentDataStep;
